<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-if="item">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{item.cy_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{item.cy_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年应收金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_year_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">当前应收余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_end}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年已收金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_received}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年未收金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_add_rec_remain_nb}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年出货金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_add_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年已对账金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.sbm_now_amount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年未对账金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_add_rec - item.sbm_now_amount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年客户入库金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年预收余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_end_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年已核金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_reduce_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">年初应收余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cy_begin_rec}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <router-link
        :to="{name: 'SaleArcheckByMonth', params: {item}}"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >对账明细表</router-link>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    if(!to.params.item)to.params.item = from.params.item || null // 兼容返回到本页
    next();
  },
  data() {
    var item = this.$route.params.item
    return {
      item
    };
  },
  computed: {
    cy_endamount() {
      return this.item.cy_nowamount - this.item.cy_nowprepayamount - this.item.cy_nowpayamount
    }
  }
}
</script>